import { render, staticRenderFns } from "./msGridEditor.vue?vue&type=template&id=63792c82&scoped=true"
import script from "./msGridEditor.vue?vue&type=script&lang=js"
export * from "./msGridEditor.vue?vue&type=script&lang=js"
import style0 from "./msGridEditor.vue?vue&type=style&index=0&id=63792c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63792c82",
  null
  
)

export default component.exports